<template>
	<div id="home">
		<v-row>
			<v-col cols="auto" :md="$i18n.locale === 'ar' ? 3 : 'auto'" xl="2" class="pb-0 pe-1">
				<div
					class="px-2 rounded-lg d-flex justify-space-between"
					style="background-color: #0b5b6f0f; width: 100%; height: 70px"
				>
					<div class="text-start d-flex flex-column justify-center align-start ">
						<p class="font-weight-bold pb-0 mb-0 pb-0 headline" > 
							<span 
								v-if="showPlannedVisitStatistics"
								class="success--text headline font-weight-bold" 	
							> {{visitsAchievements ? visitsAchievements.visitPLanned : '-'}} / 
							</span>
							<span 
								class="success--text headline font-weight-bold"
							>
								{{visitsAchievements ? visitsAchievements.visitDone : '-'}}
							</span>  
						</p>
						<p class="mb-0 caption ">
							<span v-if="showPlannedVisitStatistics">
								{{ $t('Home.visits') }} /
							</span>
							<span>
								<!-- {{$t('Home.visits-done')}} -->
								{{ $t('Home.month-visits') }}
							</span>
						</p>
					</div>
					<v-icon color="secondary" style="align-self: center"> mdi-map-marker </v-icon>
				</div>
			</v-col>
			<!-- 2 -->
			<v-col cols="auto" :md="$i18n.locale === 'ar' ? 2 : 'auto'" xl="2" class="pb-0 px-1">
				<div
					class="small-card-style px-2 rounded-lg d-flex justify-space-between align-center"
				>
					<div>
						<v-row class="text-start d-flex flex-column justify-center align-start ">
							<v-col cols="10"  class="d-flex">
								<span class="font-weight-bold success--text headline pb-0 mb-0 pb-0 " style="" > 
									{{visitCount.yesterdayVisit}}
								</span>
								
							</v-col>
							<!-- <br /> -->
						</v-row>
						<p class="mb-0 " style="font-size: 12px">
							{{ $t('Home.yesterday') }}
						</p>
					</div>
					<img v-if="0" src="@/assets/pngwing.com (16).png" width="30" />
					<img v-if="0" src="@/assets/pngwing-brown (16).png" width="30" />
					<img v-if="0" src="@/assets/Untitled-1.png" width="30" />
					<img v-if="0" src="@/assets/Untitled-alkhalil.png" width="30" />
					
				</div>
			</v-col>
			
			<!-- 3 -->
			<v-col v-if="!firstLevel" cols="auto" md="auto" xl="1" class="pb-0 px-1">
				<v-btn
					class=" px-2 rounded-lg d-flex justify-space-between text-none"
					:to="{ name:'day-off-requests' }"
					elevation="0"
					style="background-color: #0b5b6f0f; width: 100%; height: 70px"
				>
					<div class="text-start d-flex flex justify-center align-start ">
						<div class="d-flex flex-column justify-center pb-0 mb-0 pb-" style="width: 100%">  
							<span class="success--text headline font-weight-bold"> {{leaveRequests}} </span>  
							<!-- <v-spacer /> -->
							<p class="mb-0 " style="font-size: 11px">
								{{ $t('Home.leave-requests') }}
							</p>
						</div>
						<!-- <br /> -->
						<v-icon color="secondary" style="align-self: center"> mdi-calendar-alert  </v-icon>
					</div>
				</v-btn>
			</v-col>
			<!-- 4 -->
			<v-col cols="auto" md="auto" xl="1" class="pb-0 px-1">
				<v-btn
					style="background-color: #0b5b6f0f; width:100%; height: 70px"
					class="px-2 rounded-lg d-flex justify-space-between text-none"
					:to="{ 
						name: 'day-off-requests'
					}"
					elevation="0"
				>
					<div class="text-start d-flex flex-column justify-center align-start ">
						<p class="font-weight-bold pb-0 mb-0 pb-0 headline" > 
							<span class="success--text headline font-weight-bold">{{administrativeRequests}}</span>  
						</p>
						<!-- <br /> -->
						<p class="mb-0 " style="font-size: 12px">
							{{$t('Home.administrative-day')}}
						</p>
					</div>
					<v-icon color="secondary" style="align-self: center"> mdi-map-marker </v-icon>
				</v-btn>
			</v-col>
			<!-- 5 -->
			<v-col cols="auto" md="2" xl="2" class="pb-0 px-1">
				<v-btn
					style="background-color: #0b5b6f0f; width:100%; height: 70px"
					class="px-2 rounded-lg d-flex justify-space-between text-none"
					:to="{ 
						name:'modification-requests',
						params: {
							requestType: modificationRequestTypes.creation
						}
					}"
					elevation="0"
				>
					<div class=" ">
						<p class="font-weight-bold pb-0 mb-0 pb-0 headline" > 
							<span class="success--text headline font-weight-bold">{{entityCreations}}</span>  
						</p>
						<!-- <br /> -->
						<p class="mb-0 " style="font-size: 11.4px">
							{{$t('Home.customer-addition-requests')}}
						</p>
					</div>
					<v-icon color="secondary" style="align-self: center"> mdi-shape-circle-plus  </v-icon>
				</v-btn>
			</v-col>
			<!-- 6 -->
			<v-col cols="auto" :md="$i18n.locale === 'ar' ? 1 : 'auto'" xl="2" class="pb-0 px-1">
				<v-btn
					class="px-2 rounded-lg d-flex justify-space-between text-none"
					:to="{ 
						name:'modification-requests',
						params: {
							requestType: modificationRequestTypes.modification
						}
					}"
					elevation="0"
					style="background-color: #0b5b6f0f; width:100%; height: 70px"
				>
					<div class="text-start d-flex flex-column justify-center align-start ">
						<p class="font-weight-bold pb-0 mb-0 pb-0 headline" > 
							<span class="success--text headline font-weight-bold">{{entityModifications}}</span>  
						</p>
						<!-- <br /> -->
						<p class="mb-0 " style="font-size: 11.4px">
							{{$t('Home.modification-requests')}}
						</p>
					</div>
					<v-icon color="secondary" style="align-self: center"> mdi-circle-edit-outline  </v-icon>
				</v-btn>
			</v-col>
		
			<!-- 7 -->
			<v-col cols="auto" :md="$i18n.locale === 'ar' ? 2 : 'auto'" xl="2" class="pb-0">
				<v-btn
					style="background-color: #0b5b6f0f; width:100%; height: 70px"
					class="px-2 rounded-lg d-flex justify-space-between text-none"
					:to="{ 
						name:'modification-requests',
						params: {
							requestType: modificationRequestTypes.deletion
						}
					}"
					elevation="0"
				>
					<div class="text-start d-flex flex-column justify-center align-start ">
						<p class="font-weight-bold pb-0 mb-0 pb-0 headline" > 
							<span class="success--text headline font-weight-bold">{{entityDeletions}}</span>  
						</p>
						<!-- <br /> -->
						<p class="mb-0 " style="font-size: 11.4px">
							{{$t('Home.customer-deletion-requests')}}
						</p>
					</div>
					<v-icon color="secondary" style="align-self: center"> mdi-delete-circle  </v-icon>
				</v-btn>
			</v-col>
		</v-row>

		<!-- charts -->
		<v-row>
			<v-col v-if="showOutgoingAndRemainingItemsStat" lg="6" md="12" cols="12" class="py-0">
				<v-card
					style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
					class="mt-4 mx-2 rounded" 
					height="auto" 
					width="98%"
				>
					<v-card-text>
						<!-- materials -->
						<div class="d-flex">
							<v-icon color="secondary"> mdi-ballot   </v-icon>
							<p class="font-weight-bold primary--text px-1 mb-1"> 
								{{$t('Home.outgoing-and-remaining-materials')}}
							</p>
						</div>
						<v-row class="mt-2 px-5">	
							<v-col class="py-0 px-1" cols="3">
								<bee-date-picker
									v-model="fromDateMaterialsChart" 
									input-label="From Date"
									elevation="2"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										loading: submitLoading || loading
									}"
									min="1940-01-01"
									:disabled="loading || Boolean($route.query.preview)"
									:allowed-dates="disableDates"
								/>
							</v-col>

							<v-col class="py-0 px-1" cols="3">
								<bee-date-picker 
									v-model="toDateMaterialsChart"
									input-label="To Date"
									elevation="2"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										loading: submitLoading || loading
									}"
									min="1940-01-01"
									:disabled="loading || Boolean($route.query.preview)"
									:allowed-dates="disableDates"
								/>
							</v-col>

							<v-col class="py-0 px-1" align-self="center">
								<v-btn @click="getStatForOutgoing()" color="success" small class="text-none">
									{{$t('search')}} 
								</v-btn>
							</v-col>
						</v-row>
					
						<apexchart
							type="bar"
							height="320"
							width="97%"
							:loading="loadingWidelyMaterial"
							:series="seriesMaterials"
							:options="optionsMaterials"
						></apexchart>
						<v-progress-linear
							v-if="loadingWidelyMaterial"
							color="primary"
							indeterminate
							reverse
						></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-col>

			<v-col v-if="showCountEmployeeNumberStat" lg="6" md="12" cols="12" class="py-0 ">
				<v-card
					style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
					class="mt-4 mx-2 px-3 rounded" 
					height="425" 
					width="98%"
				>
					<v-card-text style="" class="ps-0">
						<!-- materials -->
						<div class="d-flex">
							<v-icon color="secondary"> mdi-ballot   </v-icon>
							<p class="font-weight-bold primary--text px-1 mb-1"> 
								{{$t('Home.number-of-employees-per-role')}} 
							</p>
						</div>

						<div v-if="!loadingEmpInRole"  class="d-flex flex-column">

							<div 
								v-for="(role, index) in employeesInRole.filter(c => c.employeesCount)" :key="index" 
								class="my-3"
							>
								<v-row justify="space-between">
									<v-col cols="12" class="d-flex justify-space-between py-0">
										<div class="d-flex justify-start" >
											<!-- <img src="@/assets/brands/users-alt.svg" width="25" /> -->													
											<h4 class="black--text mx-2"> 
												{{ role.name ? role.name : roles.find(c => c.id === role.roleId).name || 'ddd'}}		
											</h4>
										</div>

										<div class="d-flex">
											<h2 class="secondary--text py-0 mx-2">
												{{ role.employeesCount }}
											</h2>
											<img src="@/assets/brands/users-alt.svg" width="18" />
										</div>
									</v-col>
									<v-col  align-self="center">
										<v-progress-linear
											v-model="role.employeesCount"
											class="mx-2"
											height="10"
											readonly
										>
										</v-progress-linear>
									</v-col>
								</v-row>
							</div>
						</div>
						<v-progress-linear
							v-if="loadingEmpInRole"
							color="primary"
							indeterminate
							reverse
						></v-progress-linear> 
						<!-- <apexchart
							type="bar"
							height="auto"
							:loading="loadingEmpInRole"
							:series="seriesEmpInRole"
							:options="optionsEmpInRole"
						></apexchart>
						<v-progress-linear
							v-if="loadingEmpInRole"
							color="primary"
							indeterminate
							reverse
						></v-progress-linear> -->
					</v-card-text>
				</v-card>
			</v-col>
			<!-- new statistics for (employee mony) -->
			<v-col lg="6" md="12" cols="12" class="py-0">
				<v-card
					style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
					class="mt-4 mx-2 rounded scroll-style"
					height="425"
					:loading="loadingProfits"
					width="97%"
				>
					<v-card-text>
						<div class="d-flex">
							<v-icon color="secondary"> mdi-account-cash-outline </v-icon>
							<p class="font-weight-bold primary--text px-1 mb-1"> 
								{{$t('Home.each-employee-is-return-over-a-specific-time-period')}}
							</p>
						</div>

						<!-- filter -->
						<v-row class="mt-2">
							<v-col class="py-0 px-1" cols="12" md="4" align-self="center">
								<bee-date-picker
									v-model="fromDateProfits" 
									input-label="From Date"
									elevation="2"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										loading: submitLoading || loading
									}"
									min="1940-01-01"
									:disabled="loading || Boolean($route.query.preview) || submitLoading"
									:allowed-dates="disableDates"
									:loading="loading || loadingProfits"
								/>
							</v-col>

							<v-col class="py-0 px-1" cols="12" md="4" align-self="center">
								<bee-date-picker 
									v-model="toDateProfits"
									input-label="To Date"
									elevation="2"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										loading: submitLoading || loading
									}"
									min="1940-01-01"
									:disabled="loading || Boolean($route.query.preview) || submitLoading"
									:allowed-dates="disableDates"
									:loading="loading || loadingProfits"
								/>
							</v-col>

							<v-col cols="auto">
								<v-btn 
									@click="getProfit()" 
									color="success" 
									small 
									class="text-none" 
									:disabled="loadingProfits || loading"
									:loading="loadingProfits"
								> {{$t('search')}} </v-btn>
							</v-col>
						</v-row>

						<v-row justify="start">
							<v-col lg="3" md="4" sm="6" v-for="(employee, index) in employeesProfits" :key="index" align-self="start" class="px-1">	
								<v-card style="width: 100%" class="rounded-lg" color="">
									<v-card-title class="py-1 px-1">
										<div class="d-flex flex-column justify-start align-start">
											<v-img src="@/assets/male.jpg" width="30" />
											<h6 class="mx-1">
												{{ medicalRepsBrief.find(c => c.id === employee.employeeId)?.name || '' }}
											</h6>
										</div>
									</v-card-title>

									<v-divider class="mx-2" />

									<v-card-text class="d-flex py-2">
										<span>{{$t('Home.amount')}}: </span>
										<h4 class="mx-1 text-center success--text">
											{{ employee.profit }}
										</h4>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
						<v-progress-linear
							v-if="0"
							color="primary"
							indeterminate
							reverse
						></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-col>
			<!-- new -->
			<v-col v-if="!hideSomeStatistics" lg="12" md="12" cols="12" class="py-2">
				<!-- materials -->
				<v-card
					style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
					class="mt-4 mx-2 rounded" 
					height="auto" 
					width=""
				>
					<v-card-text class="pa-0">
						<v-tabs v-model="tabTopAndLessMaterials">
							<v-tab>
								{{$t('Home.the-ten-most-widely-used-materials')}}
							</v-tab>
							<v-tab>
								{{$t('Home.the-ten-stagnant-materials')}}
							</v-tab>
							<v-tabs-items  v-model="tabTopAndLessMaterials"> 
								<v-tab-item>
									<apexchart 
										type="bar" 
										height="250"
										width="95%"
										:loading="loadingWidelyMaterial"
										:series="seriesTop3Materials"
										:options="chartOptionsTop3Materials"
									></apexchart>
									<v-progress-linear
										v-if="loadingWidelyMaterial"
										color="primary"
										indeterminate
										reverse
									></v-progress-linear>
									<div v-if="0" class="d-flex justify-center py-0 my-0">
										<v-icon small color="secondary" class="mx-2"> mdi-arrow-up-circle  </v-icon>
										<h4 class="text-center  py-0 my-0"> 
											{{$t('Home.top3-commonly-used-materials')}}
										</h4>
									</div>
								</v-tab-item>

								<v-tab-item>
									<apexchart 
										type="bar" 
										height="250"
										width="100%"
										:loading="loadingWidelyMaterial"
										:series="seriesLowAmountMaterials"
										:options="lowAmountMaterialsChartOptions"
									></apexchart>
									<v-progress-linear
										v-if="loadingWidelyMaterial"
										color="primary"
										indeterminate
										reverse
									></v-progress-linear>
									<div v-if="0" class="d-flex justify-center">
										<v-icon small color="secondary" class="mx-2"> mdi-arrow-down-circle  </v-icon>
										<h4 class="text-center">{{$t('Home.least3-commonly-used-materials')}}</h4>
									</div>
								</v-tab-item>
							</v-tabs-items>
						</v-tabs>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col lg="6" md="12" cols="12" class="px-1 py-0">
				<v-row>
					<v-col v-if="0" cols="12" class="px-0 pb-0">
						<!-- staff -->
						<v-card 
							style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
							class="mt-2 mx-2 rounded" 
							height="100" 
							width=""
						>
							<v-card-text>
								<v-row class="px-2">
									<!-- staff -->
									<v-icon color="secondary" small class="mx-1"> mdi-hand-wave  </v-icon>
									<p class="primary--text font-weight-bold mb-0" > 
										{{$t('Home.welcome-new-members')}} 
									</p>
									
									<v-col v-if="staff.length" class="d-flex justify-space-between " cols="12">
										<!-- Who joined us recently -->
										<div v-for="(member, i) in staff.slice(0, 3)" :key="i" class="d-flex  text-start">
											<v-icon color="secondary"> mdi-account-multiple-plus </v-icon>
											<div>
												<p class="mb-0 mx-2 font-weight-bold"> {{member.name}} </p>
												<p class="mb-0 mx-2 text-start"> {{member.roleName}} </p>
											</div>
										</div>

									</v-col>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
					
					<!-- visits -->
					<v-col cols="12" class="py-0">
						<v-card 
							style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
							class="mt-4 mx-2 rounded" 
							height="auto" 
							width="98%"
						>
							<v-card-text class="">
								<div class="d-flex">
									<v-icon class="mx-1" color="secondary"> mdi-select-marker  </v-icon>
									<p class="font-weight-bold primary--text mb-0"> 
										{{$t('Home.number-of-visits-for-the-last-month-according-to-classification')}}
									</p>
								</div>
								<v-row class="mt-2 px-5">
									<v-col class="py-0 pe-1" cols="4" align-self="center">
										<v-autocomplete 
											v-if="managementHierarchyRegions"
											v-model="provinceId"
											label="Province"
											dense
											:items="provinces"
											item-text="name"
											item-value="id"
											hide-details
											outlined
											@change="getWorkloadByFilter()"
											:loading="submitLoading || loading"
											:disabled="loading || submitLoading || loadingClassificationStat"
										/>
										<v-autocomplete 
											v-else
											v-model="cityId"
											:label="$t('inputs.city')"
											dense
											:items="cities"
											item-text="name"
											item-value="id"
											hide-details
											outlined
											@change="getWorkloadByFilter()"
											:loading="submitLoading || loading"
											:disabled="loading || submitLoading || loadingClassificationStat"
										/>
									</v-col>
									<v-col v-if="0" class="py-0 px-1" cols="4" align-self="center">
										<bee-date-picker
											v-model="fromDate" 
											input-label="From Date"
											elevation="2"
											menu-picker
											dense
											hide-details
											:input-props="{
												outlined: true,
												dense: true,
												loading: submitLoading || loading
											}"
											min="1940-01-01"
											:disabled="loading || Boolean($route.query.preview) || submitLoading"
											:allowed-dates="disableDates"
										/>
									</v-col>

									<v-col class="py-0 px-1" cols="4" align-self="center">
										<bee-date-picker 
											v-if="0"
											v-model="toDate"
											input-label="To Date"
											elevation="2"
											menu-picker
											dense
											hide-details
											:input-props="{
												outlined: true,
												dense: true,
												loading: submitLoading || loading
											}"
											min="1940-01-01"
											:disabled="loading || Boolean($route.query.preview) || submitLoading"
											:allowed-dates="disableDates"
										/>
										<v-btn 
											@click="getWorkloadByFilter()" 
											color="success" 
											small 
											class="text-none" 
											:disabled="submitLoadingWorkLoad || loading"
											:loading="submitLoadingWorkLoad"
										> {{$t('search')}} </v-btn>
									</v-col>
								</v-row>
								<apexchart
									type="bar"
									height="320"
									width="97%"
									:loading="loadingClassificationStat"
									:series="series"
									:options="options"
								></apexchart>
								<v-progress-linear
									v-if="loadingClassificationStat"
									color="primary"
									indeterminate
									reverse
								></v-progress-linear>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
			<v-col v-if="enableRateVisitDependingNumberCustomer" lg="6" md="12" cols="12" class="py-0">
				<v-card
					style="	box-shadow: -4px 3px 37px -3px #e8e7e76e" 
					class="mt-2 rounded" 
					height="auto" 
					width="100%"
				>
					<v-card-text>
						<div class="d-flex">
							<v-icon color="secondary" class="mx-1"> mdi-semantic-web  </v-icon>
							<p class="mb-0 primary--text font-weight-bold"> 
								{{$t('Home.number-of-visits-for-the-last-week-depending-on-the-number-of-customers')}}
							</p>
						</div>
						<v-row class="px-5 mt-2">
							<v-col cols="6" align-self="center" class="py-0 pe-1">
								<v-autocomplete
									v-model="cityIdVisitsRate"
									:items="cities"
									item-text="name"
									item-value="id"
									:label="$t('inputs.city')"
									outlined
									hide-details
									dense
									:loading="loading"
									:disabled="loadingNumberVisit || loading"
								/>
							</v-col>

							<v-col v-if="0" cols="3">
								<bee-date-picker 
									v-model="fromDateVisitsToEntity" 
									input-label="From Date"
									elevation="2"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										loading: submitLoading || loadingNumberVisit
									}"
									min="1940-01-01"
									:disabled="loading || Boolean($route.query.preview) || submitLoading"
									:allowed-dates="disableDates"
								/>
							</v-col>

							<v-col v-if="0" cols="3">
								<bee-date-picker 
									v-model="toDateVisitsToEntity" 
									input-label="To Date"
									elevation="2"
									menu-picker
									dense
									hide-details
									:input-props="{
										outlined: true,
										dense: true,
										loading: submitLoading || loading
									}"
									min="1940-01-01"
									:disabled="loading || Boolean($route.query.preview) || submitLoading"
									:allowed-dates="disableDates"
								/>
							</v-col>

							<v-col cols="2" align-self="center" class="py-0 pe-1">
								<v-btn 
									@click="getVisitsToEntity()" 
									color="success" 
									small 
									class="text-none"
									:disabled="loading || submitLoading || loadingNumberVisit"
									:loading="submitLoading"
									
								>
									{{$t('search')}}
								</v-btn>
							</v-col>
						</v-row>
						<apexchart
							type="bar"
							height="320"
							width="97%"
							:series="seriesRateVisit"
							:options="chartOptionsRateVisit"
						></apexchart>
						<v-progress-linear
							v-if="loadingNumberVisit"
							color="primary"
							indeterminate
							reverse
						></v-progress-linear>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';
import { firstLevel, managementHierarchyRegions, hideSomeStatistics, showOutgoingAndRemainingItemsStat, showCountEmployeeNumberStat, showPlannedVisitStatistics, newColumnForWorkloadStatistics, isDisabledFriday, enableRateVisitDependingNumberCustomer } from '@/configs/global.config'
import { makeTree, disableDates } from '@/helpers/functions';
import { modificationRequestTypes } from '@/helpers/enums'
	export default {
		name: 'Home',

		data(){
			return {
				loadingClassificationStat: false,
				loadingMaterial: false,
				loadingWidelyMaterial: false,
				loadingNumberVisit: false,
				fromDateVisitsToEntity:  moment(moment().subtract(6, 'days')).format('YYYY-MM-DD'),
				toDateVisitsToEntity: moment().format('YYYY-MM-DD'),
				tab: 0,
				tabTopAndLessMaterials: 0,
				fromDateMaterialsChart: null,
				toDateMaterialsChart: null,
				visitsNumber: null,
				totalVisitsNumber: null,
				leaveRequests: 0,
				administrativeRequests: 0,
				entityModifications: 0,
				entityCreations: 0,
				entityDeletions: 0,
				cityId: null,
				fromDate: moment(moment().startOf('month')).format('YYYY-MM-DD'),
				toDate: moment().format('YYYY-MM-DD'),
				loading: false,
				submitLoading: false,
				cityIdVisitsRate: null,
				fromDateVisitsRate: moment(moment().subtract(6, 'days')).format('YYYY-MM-DD'),
				toDateVisitsRate: moment().format('YYYY-MM-DD'),
				submitLoadingWorkLoad: false,
				firstLevel,
				provinceId: null,
				employeesInRole: [],
				loadingEmpInRole: false,
				// config
				managementHierarchyRegions,
				hideSomeStatistics,
				showOutgoingAndRemainingItemsStat,
				showCountEmployeeNumberStat,
				showPlannedVisitStatistics,
				newColumnForWorkloadStatistics,
				isDisabledFriday,
				roleId: JSON.parse(localStorage.getItem('auth')).roleId,
				disableDates,
				enableRateVisitDependingNumberCustomer,
				modificationRequestTypes,
				loadingProfits: false,
				employeesProfits: [],
				fromDateProfits: moment().startOf('month').format('YYYY-MM-DD'),
				toDateProfits: moment().format('YYYY-MM-DD')
			}
		},
		
		computed:{
			...mapState({
				medicalRepsBrief: state => state.medicalreps.medicalRepsBrief,
				classification: state => state.workload.classification,
				workloadVisits: state => state.statisticsHome.workloadVisits?.filter(c => c.workloadId !== null),
				staff: state => state.statisticsHome.staff.lastEmployees,
				visitsAchievements: state => state.statisticsHome.visitsAchievements,
				visitCount: state => state.statisticsHome.visitCount,
				staffRequests: state => state.statisticsHome.staffRequests,
				materialsStat: state => state.statisticsHome.materialsStat,
				materials: state => state.materials.materials,
				teams: state => state.statisticsHome.teams,
				allTeams: state => state.teams.teams,
				cities: state => state.cities.cities,
				entitiesVisits: state => state.statisticsHome.entitiesVisits,
				regionsAll: state => state.regions.regionsAll,
				provinces: state => state.provinces.provinces,
				roles: state => state.rolePermission.roles,
				specialties: state => state.specialties.specialties,
				isSuperAdmin: state => state.auth.isSuperAdmin,
				employeeId: state => state.auth.self.employeeId,
				userData: state => state.auth.userData
			}),

			...mapGetters({
				getClassificationById: 'workload/getClassificationById',
				getMaterialById: 'materials/getMaterialById',
				getTeamById: 'teams/getTeamById',
				getRegionAllById: 'regions/getRegionAllById',
				getRoleById: 'rolePermission/getRoleById',
			}),

			regionsName() {
				return this.entitiesVisits.length ? this.entitiesVisits?.slice(0, 20).map(c => this.getRegionAllById(c.visits.regionId)?.name) : [] 
			},

			// classification
			series() {
				const series = [
					{
						name:  this.$t('Home.visit-count'),
						data: this.workloadVisits?.map(c => c.visitCount)
					},
					{
						name: this.$t('Home.entity-count'),
						data: this.workloadVisits?.map(c => c.entityCount)
					}
				]
				if (this.newColumnForWorkloadStatistics) {
					series.push({
						name: 'Visit count distinct',
						data: this.workloadVisits?.map(c => c.visitCountDistinct)
					})
				}
				return series
			},

			options() { 
				return {
					chart: {
						id: 'vuechart-example',
						// locales: [{
						// 	name: 'en',
						// 	options: {
						// 	months: ['كانون الثاني', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
						// 	shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
						// 	days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
						// 	shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
						// 	toolbar: {
						// 		download: 'Download SVG',
						// 		selection: 'Selection',
						// 		selectionZoom: 'Selection Zoom',
						// 		zoomIn: 'Zoom In',
						// 		zoomOut: 'Zoom Out',
						// 		pan: 'Panning',
						// 		reset: 'Reset Zoom',
						// 	}
						// 	}
						// }]
					},
					xaxis: {
						categories: this.workloadVisits?.length ? this.workloadVisits?.map(c => this.getClassificationById(c.workloadId)?.name) : []
					}
				}
			},
			// labels
			labels () {
				return	this.classification?.map(c => c.name)
			},

			// Remaining
			seriesMaterials() {
				return [
					{
						name: this.$t('Home.deliver-amount'),
						data: this.materialsStat?.materialState.length ? this.materialsStat?.materialState?.slice(0, 10).map(c => c.amountDeliverd) : []
						
					},
					{
						name: ('Home.remaining'),
						data: this.materialsStat?.materialState.length ? this.materialsStat?.materialState?.slice(0, 10).map(c => c.amountInWarehouse) : []
					}
				]
			},
			optionsMaterials() {
                return {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: this.materialsStat?.materialState.length ? this.materialsStat?.materialState?.slice(0, 10).map(c => this.getMaterialById(c.materialId)?.name) : [],
                    },
                    yaxis: {
                        title: {
                            
                        }
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                            	return val 
							}
                    	}
                	}
            	}
        	},

			seriesEmpInRole() {
				return [
					{
						name: this.$t('Home.count-employee'),
						data: this.employeesInRole?.map(c => c.employeesCount)
					}
				]
			},

			optionsEmpInRole() {
                return {
                    chart: {
                        type: 'bar',
                        height: 350
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            columnWidth: '55%',
                            endingShape: 'rounded'
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },
                    xaxis: {
                        categories: this.employeesInRole?.length ? this.employeesInRole?.map(c => this.getRoleById(c.roleId)?.name) : []
                    },
                    fill: {
                        opacity: 1
                    },
                    tooltip: {
                        y: {
                            formatter: function (val) {
                            	return val 
							}
                    	}
                	}
            	}
        	},

			// labels() {
			// 	return	this.classification.map(c => c.name)
			// },

			// quantity and team
			quantityInTeam() {
				return [
					{
						name: this.$t('Home.quantity-received'),
						data: this.teams.map(c => c.inAmountSum)
						
					},
					{
						name: this.$t('Home.quantity-delivered'),
						data: this.teams.map(c => c.outAmountSum)
					}
				]
			},

			optionsMaterialsTeam() {
				return {
					chart: {
						id: 'vuechart-example'
					},
					xaxis: {
						categories: this.teams.map(c => this.getTeamById(c.teamId)?.name)
					}
      			}
			},

			// circle
			seriesTop3Materials() {
				return [{
					name: '',
					data: this.materialsStat?.topMaterial.length ? this.materialsStat?.topMaterial?.slice(0, 10).map(c => c.materialAmount) : []
				}]
			},

			chartOptionsTop3Materials () {
				return {
					chart: {
						height: 350,
						type: 'bar',
					},
					plotOptions: {
						bar: {
							borderRadius: 0,
                            width: '300px',
							dataLabels: {
								position: 'top', // top, center, bottom
							},
						}
					},
					dataLabels: {
						enabled: true,
						offsetY: -20,
						style: {
							fontSize: '12px',
							colors: ["#304758"]
						}
					},
            
					xaxis: {
						categories: this.materialsStat?.topMaterial.length ? this.materialsStat.topMaterial?.slice(0, 10).map(c => this.getMaterialById(c.materialId)?.name) : [],
						// position: 'top',
						axisBorder: {
							show: false
						},
						axisTicks: {
							show: false
						},
						crosshairs: {
							fill: {
							type: 'gradient',
							gradient: {
								colorFrom: '#D8E3F0',
								colorTo: '#BED1E6',
								stops: [0, 100],
								opacityFrom: 0.4,
								opacityTo: 0.5,
							}
							}
						},
						tooltip: {
							enabled: true,
						}
					},
					yaxis: {
						axisBorder: {
							show: true
						},
						axisTicks: {
							show: false,
						},
						labels: {
							show: true,
							formatter: function (val) {
								return val
							}
						}
						
					},
					// title: {
					// 	text: 'Top 3 commonly used materials',
					// 	floating: true,
					// 	offsetY: 330,
					// 	align: 'bottom',
					// 	style: {
					// 		color: '#444'
					// 	}
					// }
				}
			},

			seriesLowAmountMaterials () {
				// return this.materialsStat?.lessMaterial.map(c => c.materialAmount)
				return [{
					name: 'less 3',
					data: this.materialsStat?.lessMaterial.length ? this.materialsStat?.lessMaterial?.slice(0, 10).map(c => c.materialAmount) : []
				}]
			},

			lowAmountMaterialsChartOptions () {
				// return {
				// 	chart: {
				// 		id: 'vuechart-example'
				// 	},
				// 	xaxis: {
				// 		categories: this.materialsStat?.lessMaterial.map(c => this.getMaterialById(c.materialId)?.name)
				// 	}
      			// }
				return {
					chart: {
						height: 350,
						type: 'bar',
					},
					plotOptions: {
						bar: {
							borderRadius: 0,
                            width: '300px',
							dataLabels: {
								position: 'top', // top, center, bottom
							},
						}
					},
					dataLabels: {
						enabled: true,
						offsetY: -20,
						style: {
							fontSize: '12px',
							colors: ["#304758"]
						}
					},
            
					xaxis: {
						categories: this.materialsStat?.lessMaterial.length ? this.materialsStat?.lessMaterial.map(c => this.getMaterialById(c.materialId)?.name) : [],
						// position: 'top',
						axisBorder: {
							show: false
						},
						axisTicks: {
							show: false
						},
						crosshairs: {
							fill: {
							type: 'gradient',
							gradient: {
								colorFrom: '#D8E3F0',
								colorTo: '#BED1E6',
								stops: [0, 100],
								opacityFrom: 0.4,
								opacityTo: 0.5,
							}
							}
						},
						tooltip: {
							enabled: true,
						}
					},
					yaxis: {
						axisBorder: {
							show: true
						},
						axisTicks: {
							show: false,
						},
						labels: {
							show: true,
							formatter: function (val) {
								return val
							}
						}
						
					},
					title: {
						text: 'Monthly Inflation in Argentina, 2002',
						floating: true,
						offsetY: 330,
						align: 'center',
						style: {
							color: '#444'
						}
					}
				}
			},

			// new (medRep-ent-visits) 
        	seriesRateVisit() {
                return [
                    {
                        name: this.$t('Home.visits-number'),
						data: this.entitiesVisits.length ? this.entitiesVisits?.slice(0, 20).map(c => c.visits.count) : []
                    }, 
                    {
                        name: this.$t('Home.entities-number'),
						data: this.entitiesVisits.length ? this.entitiesVisits?.slice(0, 20).map(c => c.entities.count) : []
                    }, 
                ]
			}, 
          	chartOptionsRateVisit () {
				return {
					chart: {
						type: 'bar',
						height: 450,
						stacked: true,
					},
					stroke: {
						width: 1,
						colors: ['#fff']
					},
					xaxis: {
						categories: this.regionsName,
						labels: {
							formatter: function (val) {
							return val
							}
						}
					},
					yaxis: {
						title: {
							text: undefined
						},
					},
					tooltip: {
					y: {
						formatter: function (val) {
						return val
						}
					}
					},
					fill: {
					opacity: 1
					},
					legend: {
					position: 'top',
					horizontalAlign: 'left',
					offsetX: 40
					}
          		}
			}
        },

		methods:{
			moment,
			getWorkloadByFilter() {
				this.submitLoadingWorkLoad = true
			
				this.$store.dispatch('statisticsHome/fetchWorkloadVisits', { 
					fromDate: this.fromDate, 
					toDate: this.toDate,
					cityId: !managementHierarchyRegions ? this.cityId : null,
					provinceId: managementHierarchyRegions ? this.provinceId : null
				}).finally(() => {
					this.submitLoadingWorkLoad = false
				})
			},

			getVisitsToEntity () {
				this.submitLoading = true
				this.$store.dispatch('statisticsHome/fetchEntitiesVisits', {
					cityId: this.cityIdVisitsRate,
					fromDate: this.fromDateVisitsRate,
					toDate: this.toDateVisitsRate,
				}).finally(() => {
					this.submitLoading = false
				})
			},

			getStatForOutgoing() {
				this.loadingWidelyMaterial = true 
				this.$store.dispatch('statisticsHome/fetchMaterials', { 
					fomDate: this.fromDateMaterialsChart,
					toDate: this.toDateMaterialsChart
				}).finally(() => {
					this.loadingWidelyMaterial = false
				})
			},

			getProfit() {
				this.loadingProfits = true
				this.$store.dispatch('visits/fetchProfits', { fromDate: this.fromDateProfits, toDate: this.toDateProfits }).then((data) => {
					this.employeesProfits = data
				}).finally(() => {
					this.loadingProfits = false
				})
			}
		},

		created() {
			this.loading = true;
			// this.$store.dispatch('medicalreps/fetchAll', true)
			Promise.all([
				managementHierarchyRegions 
				? this.$store.dispatch('provinces/fetchAll') 
				: null,

				showCountEmployeeNumberStat 
				? this.$store.dispatch('rolePermission/fetchChildrenRole', { id: this.employeeId })
				: null,

				this.getProfit()
			]).then(() => {
				if (showCountEmployeeNumberStat) {
					this.loadingEmpInRole = true
					this.$store.dispatch('statisticsHome/fetchRoleAndNumberEmp').then((data) => {
						if (this.isSuperAdmin) {
							const buildSortedArray = (node) => {
								const result = [node];
								if (node.children) {
									node.children.forEach(child => {
										result.push(...buildSortedArray(child));
									});
								}
								return result;
							};
							const sortedRoles = Object.values(makeTree(this.roles)).flatMap(buildSortedArray);
						
							this.employeesInRole = sortedRoles.map(c => ({ ...c, employeesCount: data.find(v => v.roleId === c.id)?.employeesCount }))
						} else {
							const mainParentId = this.userData.role.id 
							this.employeesInRole = data
							for (let i = 0; i < this.employeesInRole.length; i++) {
								for (let j = 0; j < this.employeesInRole.length - 1; j++) {
									if (this.employeesInRole[j].ParentRoleId !== mainParentId && this.employeesInRole[j + 1].ParentRoleId === mainParentId) {
										const temp = this.employeesInRole[j];
										this.employeesInRole[j] = this.employeesInRole[j + 1];
										this.employeesInRole[j + 1] = temp;
									}
								}
							}
							this.employeesInRole = this.employeesInRole.reverse()
						}
			
						this.loadingEmpInRole = false
					}).finally(() => {
						this.loadingEmpInRole = false
					})
				}

				this.loading = false
				if (!this.cities.length) {
					this.$store.dispatch('cities/fetchCityMine', {})
				}
				
				this.$store.dispatch('regions/fetchAllRegions', { cities: this.cities })
				if (!this.classification.length) {
					this.$store.dispatch('workload/fetchAll')
				}
				window.axios.get('/home').then(response => {
					this.leaveRequests = response.data.leaveRequests;
					this.administrativeRequests = response.data.administrativeRequests;
					this.entityModifications = response.data.entityModifications;
					this.entityCreations = response.data.entityCreations;
					this.entityDeletions = response.data.entityDeletions;
					this.visitsNumber = response.data.visitsYesterday;
					this.totalVisitsNumber = response.data.visitTargets;
				})
				this.$store.dispatch('statisticsHome/fetchVisitsAchievements', {
					fromDate: this.moment(this.moment().startOf('month')).format('YYYY-MM-DD'),
					toDate: this.moment().format('YYYY-MM-DD') 
				})

				this.$store.dispatch('statisticsHome/fetchVisitsCount', { 
					fromDate: this.moment(this.moment().startOf('month')).format('YYYY-MM-DD'), 
					toDate: this.moment().format('YYYY-MM-DD') 
				})
			}).catch(() => {
				this.loading = false
			})
		},

		metaInfo: {
			title: 'Octopharma'
		},
	}
</script>
<style scoped>
.btn-num {
	font-size: 30px;
	font-weight: bolder;
	background-color: #12da1c;
}
.fs-m {
	font-size: 23px;
	font-weight: bolder;
}
p {
	font-family: 'Cairo';
}

span {
	font-family: 'Cairo';
}
.scroll-style {
    float:left;
    overflow-y: auto;
}
</style>

<style>
span.apexcharts-legend-text {
	font-family: 'Cairo' !important;
}
</style>
